/*
 * @Description: Description
 * @Author: wning
 * @Date: 2020-07-20 15:51:11
 * @LastEditors: wning
 * @LastEditTime: 2020-07-20 17:22:48
 */
export default {
  /**查询列表 */
  GET_LIST_API: '/component/approvalCentre/list',
  /**审批*/
  GET_APPROVAL_API: '/component/approvalCentre/approval',
};
